const baseUrl = '/settings/mailjet';
export default {

    getConfig() {
        return new Promise((resolve, reject) => {
            ApiClient.get(baseUrl, {}).then((response) => {
                resolve(response);
            }).catch((err) => {
                reject(err);
            });
        });
    },

    saveConfig(data, method) {
        return new Promise((resolve, reject) => {
            ApiClient.call({url: baseUrl, params: {}, data: data, method: method}).then((response) => {
                resolve(response);
            }).catch((err) => {
                reject(err);
            });
        });
    },
};
